import { apiConfig } from 'core-lib/config/config';
import { getMethod } from 'core-lib/utils/apiV2';
import { getDefaultHeaders } from 'core-lib/utils/network';

const serializer = (data) => {
  const obj = {
    isServiceable: data?.is_serviceable,
    maxExpected: Number(data?.max),
    minExpected: data?.min,
    deliveryMessage: data?.delivery_message,
  };
  return obj;
};

export const checkExpectedDelivery = (pincode, pickUpPostCode) =>
  new Promise<{ response?: any; error?: any }>((resolve) => {
    (async (pincode) => {
      const url = `${apiConfig(
        'fulfillmentOriginal'
      )}/delivery/new-expected-delivery?weight=0.5&cod=0&delivery_postcode=${pincode}${
        pickUpPostCode ? `&pickup_postcode=${pickUpPostCode}` : ''
      }`;
      const { response, error }: any = await getMethod({
        endPoint: url,
        headers: getDefaultHeaders({ deviceId: true }),
      });
      if (response) {
        resolve({ response: serializer(response?.data) });
      }
      if (error) {
        resolve({ error });
      }
    })(pincode);
  });
